import { render, staticRenderFns } from "./superfeatures.vue?vue&type=template&id=2ed6ecdf&scoped=true&lang=pug&"
import script from "./superfeatures.vue?vue&type=script&lang=js&"
export * from "./superfeatures.vue?vue&type=script&lang=js&"
import style0 from "./superfeatures.vue?vue&type=style&index=0&id=2ed6ecdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed6ecdf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsResultsCell: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/widgets/results/cell.vue').default,WidgetsResultsMiniTable: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/widgets/results/mini-table.vue').default})
